
import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/user',
  component: () => import('@views/User/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'user.index',
      component: () => import('@/components/User/UserInfo')
    },
    {
      path: 'management',
      name: 'user.management',
      component: () => import('@/components/User/UserManagement')
    },
  ]
}
